import { observer } from "mobx-react";
import React, { useEffect, useMemo, useState } from "react";
import { getFormValidation } from "src/Shared/Components";
import { EDITOR_TYPES } from "src/Shared/Enums";
import { VIEW_MODE } from "src/Shared/Enums/ViewMode.enum";
import { IGridFormControlProps } from "src/Shared/Interfaces/IGridFormControlProps.interface";
import { fields } from "./fields";
import ModalContent from "src/Shared/Components/ModalContent/ModalContent";
import GridFormControl from "src/Shared/Components/GridFormControl/GridFormControl";
import { ICompanyAdditionalRevenueStream } from "../../Interfaces/ICompanyAdditionalRevenueStream";
import CompanyRevenueService from "../../Services/CompanyRevenue.service";
import { ToastService } from "src/Shared/Services";
import { finalize } from "rxjs";
import { IResult } from "src/Shared/Interfaces";
import { AxiosError } from "axios";
import { useModal, useStore } from "src/Shared/Hooks";

type Props = {
  mode: VIEW_MODE;
  companyRowID: string;
  additionalRevenue?: ICompanyAdditionalRevenueStream;
};

const AddOrEditCompanyAdditionalRevenue: React.FC<Props> = ({
  mode,
  companyRowID,
  additionalRevenue,
}) => {
  const [buttonText, setbuttonText] = useState<string>("Add");
  const [tittle, settittle] = useState<string>("Add Additional Revenue");
  const [loading, setLoading] = useState<boolean>(false);
  const { close } = useModal();
  const {
    rootStore: {
      companyRevenueStore: { getCompanyRevenue },
    },
  } = useStore();

  const companyAdditionalRevenueForm = useMemo(
    () => getFormValidation(fields),
    []
  );
  const getField = (key: string) => companyAdditionalRevenueForm.$(key);

  useEffect(() => {
    switch (mode) {
      case VIEW_MODE.ADD:
        {
        }
        break;
      case VIEW_MODE.EDIT:
        {
          setbuttonText("Update");
          settittle("Edit Additional Revenue");
        }
        break;
    }
  }, []);

  useEffect(() => {
    if (additionalRevenue && mode == VIEW_MODE.EDIT) {
      companyAdditionalRevenueForm.set(additionalRevenue);
    }
  }, [additionalRevenue]);

  const gridProps: IGridFormControlProps = {
    row: 1,
    col: 3,
    itemResponsive: {
      lg: 12,
      sm: 12,
      md: 4,
    },
    inputControls: [
      {
        field: getField("serviceName"),
        fieldKey: "serviceName",
        type: EDITOR_TYPES.TEXT_FIELD,
      },
      {
        field: getField("value"),
        fieldKey: "value",
        type: EDITOR_TYPES.TEXT_FIELD,
        isMasked: true,
      },
      {
        field: getField("date"),
        fieldKey: "date",
        type: EDITOR_TYPES.DATE,
      },
    ],
    form: companyAdditionalRevenueForm,
  };

  const gridPropsForInfo: IGridFormControlProps = {
    row: 2,
    col: 4,
    itemResponsive: {
      lg: 6,
      sm: 12,
      md: 4,
    },
    inputControls: [
      {
        field: getField("createdBy"),
        fieldKey: "createdBy",
        type: EDITOR_TYPES.TEXT_FIELD,
        isEditingMode: false,
      },
      {
        field: getField("createdOn"),
        fieldKey: "createdOn",
        type: EDITOR_TYPES.TEXT_FIELD,
        isEditingMode: false,
      },
      {
        field: getField("updatedBy"),
        fieldKey: "updatedBy",
        type: EDITOR_TYPES.TEXT_FIELD,
        isEditingMode: false,
      },
      {
        field: getField("updatedOn"),
        fieldKey: "updatedOn",
        type: EDITOR_TYPES.TEXTAREA,
        isEditingMode: false,
      },
    ],
    form: companyAdditionalRevenueForm,
  };

  const onFromSubmit = () => {
    if (!companyAdditionalRevenueForm.isValid) {
      companyAdditionalRevenueForm.showErrors();
      return;
    }
    const request: ICompanyAdditionalRevenueStream = {
      ...companyAdditionalRevenueForm.values(),
    };
    request.companyRowID = companyRowID;
    setLoading(true);
    CompanyRevenueService.addOrEditAdditionalRevenueStream(request)
      .pipe(
        finalize(() => {
          setLoading(false);
        })
      )
      .subscribe({
        next: (data: IResult<string>) => {
          ToastService.success(data.message);
          close();
          getCompanyRevenue(companyRowID);
        },
        error: (error: AxiosError) => ToastService.axiosError(error),
      });
  };
  return (
    <ModalContent
      onSaveButtonClick={onFromSubmit}
      buttonText={buttonText}
      title={tittle}
      btnLoading={loading}
    >
      <GridFormControl {...gridProps} />
      {mode == VIEW_MODE.EDIT && <GridFormControl {...gridPropsForInfo} />}
    </ModalContent>
  );
};

export default observer(AddOrEditCompanyAdditionalRevenue);
